export const TILES_TO_SHOW = 8;
